import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import { Btn, LI } from '../../../AbstractElements';
import { firebase_app } from '../../../Config/Config';
import { LogOut } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';

const LogoutClass = () => {
    const history = useNavigate();
    const Logout = () => {
        localStorage.removeItem('profileURL');
        localStorage.removeItem('token');
        firebase_app.auth().signOut();

        localStorage.removeItem('auth0_profile');
        localStorage.removeItem('Name');
        localStorage.setItem('authenticated', false);
        history(`${process.env.PUBLIC_URL}/home`);
    };
    const Logoutt = () => {
        // Clear localStorage or any authentication data
        localStorage.removeItem("uniqueToken");
        localStorage.removeItem("userdata");
        localStorage.clear(); // Clears all data in localStorage if necessary
      
        // Optionally, you can also clear cookies or session storage if used
        sessionStorage.clear();
      
        // Redirect to login
        window.location.href = `${process.env.PUBLIC_URL}/home`;
      };
      

    return (
        <Fragment>
            <LI attrLI={{ className: 'onhover-dropdown p-0', onClick: Logoutt }} >
                <Btn attrBtn={{ as: Card.Header, className: 'logout-btn', color: 'default' }} >
                    <Link to={`${process.env.PUBLIC_URL}/home`}>
                        {/* <span className=''>Log out</span> */}
                        <LogOut />
                    </Link>
                </Btn>
            </LI>
        </Fragment>
    );
};

export default LogoutClass;